import { Affix, Button, Checkbox, Form, Input } from 'antd';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate, useParams } from 'react-router-dom';
import ModalConfirm from '../../../../components/Shared/modal/confirm';
import ModalDiscardChanges from '../../../../components/Shared/modal/discardChanges';
import useNotify from '../../../../context/Notification/useNotify';
import RopaServices from '../../../../services/Ropa.service';
import { useBlocker } from '../../../../util/usePrompt';
import { ROUTER } from '../../../../constants/router';

const { TextArea } = Input;

export default function Tab4({
    collectDataDestruction,
    getRopaDetail,
    storageLocation,
}) {
    const [form] = Form.useForm();
    const { t, i18n } = useTranslation();
    const { activityId } = useParams();
    const navigate = useNavigate();
    const notify = useNotify();

    const [prevent, setPrevent] = useState([]);
    const [ownerAccess, setOwnerAccess] = useState([]);

    // Confirm
    const [openConfirm, setOpenConfirm] = useState(false);
    const [valueSave, setValueSave] = useState();
    const [loading, setLoading] = useState(false);

    // Discard change
    const [change, setChange] = useState(false);
    const [openChange, setOpenChange] = useState(false);
    const [nextLocation, setNextLocation] = useState(null);
    const [isChangeLocation, setIsChangeLocation] = useState(false);

    useBlocker((nextLocation) => onChangePage(nextLocation), change === true);

    const onChangePage = (nextLocation) => {
        setOpenChange(true);
        setIsChangeLocation(true);
        setNextLocation(nextLocation);
    };

    const handelOk = async () => {
        setOpenChange(false);
        setChange(false);
    };

    const handelOkLocation = async () => {
        setOpenChange(false);
        setChange(false);
        setIsChangeLocation(false);
        await form.resetFields();
        await getRopaDetail();
        await navigate(
            nextLocation.location.pathname + nextLocation.location.search
        );
    };

    useEffect(() => {
        const getMasterPrevent = async () => {
            try {
                const { data } = await RopaServices.getMasterPrevent(
                    activityId
                );
                if (data?.resultData) {
                    setPrevent(data?.resultData);
                }
            } catch (error) {
                console.log(error);
            }
        };
        const getMasterOwner = async () => {
            try {
                const { data } = await RopaServices.getMasterOwner(activityId);
                if (data?.resultData) {
                    setOwnerAccess(data?.resultData);
                }
            } catch (error) {
                console.log(error);
            }
        };
        getMasterPrevent();
        getMasterOwner();
    }, [activityId]);

    useEffect(() => {
        if (collectDataDestruction) {
            form.setFieldsValue({
                ...collectDataDestruction,
            });
        }
    }, [collectDataDestruction, form]);

    const onFinish = () => {
        createCollectionData({
            activityId,
            ownerAccessDelete: valueSave.ownerAccessDelete,
            preventControlDataDetail: valueSave.preventControlDataDetail,
            storageLocation: valueSave.storageLocation,
        });
    };

    const createCollectionData = async (payload) => {
        setLoading(true);
        try {
            const { data } = await RopaServices.updateCollectDataAndDestruction(
                payload
            );
            if (data?.resultCode === 1) {
                notify({
                    title: t('common.Success'),
                    description: t('Successfully to submitted'),
                });
                setOpenChange(false);
                setChange(false);
                // getDataFlowDetail(businessProcessId);
                setLoading(false);
                setOpenConfirm(false);
                navigate(
                    `${ROUTER.DS_INVENTORY.ROPA}/${activityId}/view?tab=4`
                );
            }
        } catch (error) {
            console.log(error);
            setLoading(false);
            notify({
                type: 'error',
                title: t('common.Fail'),
                description: t('Failed to submitted'),
            });
            setOpenConfirm(false);
        }
    };

    const onCancel = (e) => {
        navigate(`${ROUTER.DS_INVENTORY.ROPA}/${activityId}/view?tab=4`);
    };

    return (
        <div>
            <Form
                scrollToFirstError={{
                    behavior: 'smooth',
                    block: 'center',
                }}
                layout="vertical"
                form={form}
                onFinish={(value) => {
                    setOpenConfirm(true);
                    setValueSave(value);
                }}
                onFieldsChange={(_, allFields) => {
                    if (allFields.length > 0) {
                        setChange(true);
                    }
                }}
            >
                <Affix offsetTop={60}>
                    <div className="flex justify-end space-x-3">
                        <Button
                            size="large"
                            type="default"
                            className="text-purple-PHX border-purple-PHX w-32"
                            onClick={onCancel}
                        >
                            {t('common.Cancel')}
                        </Button>
                        <Button
                            size="large"
                            type="primary"
                            className="w-32"
                            htmlType="submit"
                        >
                            {t('common.Save')}
                        </Button>
                    </div>
                </Affix>
                {/* <Form.Item
                    label={
                        <span className="text-[21px] font-bold">
                            ระยะเวลาการจัดเก็บข้อมูล
                        </span>
                    }
                    rules={[
                        {
                            required: true,
                            message: 'This field is required.',
                        },
                    ]}
                >
                    <div className="flex items-center space-x-2">
                        <div className="w-1 h-1 bg-black rounded-full" />
                        <div>{collectDataDestruction?.retentionData}</div>
                    </div>
                </Form.Item> */}
                <Form.Item
                    label={
                        <span className="text-[21px] font-bold">
                            {t('dataFlow.storageLocation')}
                        </span>
                    }
                    name="storageLocation"
                    rules={[
                        {
                            required: true,
                            message: t('errorText.requiredField'),
                        },
                    ]}
                >
                    <Checkbox.Group className="w-full mb-1">
                        {storageLocation.map((is) => {
                            return (
                                <div key={is.id}>
                                    <Checkbox
                                        key={is.id}
                                        value={is.id}
                                        style={{ lineHeight: '32px' }}
                                    >
                                        {i18n.lang === 'en' ? is.name : is.name}
                                    </Checkbox>
                                    <br />
                                </div>
                            );
                        })}
                    </Checkbox.Group>
                </Form.Item>
                <Form.Item
                    name="processRequestingDataApproval"
                    label={
                        <span className="text-[21px] font-bold">
                            {t('dataFlow.processRequestingDataApproval')}
                        </span>
                    }
                    rules={[
                        {
                            required: true,
                            message: t('errorText.requiredField'),
                        },
                    ]}
                >
                    <TextArea
                        disabled
                        size="large"
                        rows={4}
                        placeholder={t('dataFlow.inputpl3')}
                    />
                </Form.Item>
                <Form.Item
                    label={
                        <span className="text-[21px] font-bold">
                            {t('dataFlow.preventControlDataDetails')}
                        </span>
                    }
                    name="preventControlDataDetail"
                    rules={[
                        {
                            required: true,
                            message: t('errorText.requiredField'),
                        },
                    ]}
                >
                    <Checkbox.Group className="w-full mb-1">
                        {prevent.map((is) => {
                            return (
                                <div key={is.id}>
                                    <Checkbox
                                        key={is.id}
                                        value={is.id}
                                        style={{ lineHeight: '32px' }}
                                    >
                                        {i18n.lang === 'en' ? is.name : is.name}
                                    </Checkbox>
                                    <br />
                                </div>
                            );
                        })}
                    </Checkbox.Group>
                </Form.Item>
                <Form.Item
                    name="stepToDeleteDestructionData"
                    label={
                        <span className="text-[21px] font-bold">
                            {t('dataFlow.stepTodeleteDestructionData')}
                        </span>
                    }
                    rules={[
                        {
                            required: true,
                            message: t('errorText.requiredField'),
                        },
                    ]}
                >
                    <TextArea
                        disabled
                        size="large"
                        rows={4}
                        placeholder={t('dataFlow.stepTodeleteDestructionData')}
                    />
                </Form.Item>
                <Form.Item
                    label={
                        <span className="text-[21px] font-bold">
                            {t('dataFlow.ownerAcessDelete')}
                        </span>
                    }
                    name="ownerAccessDelete"
                    rules={[
                        {
                            required: true,
                            message: t('errorText.requiredField'),
                        },
                    ]}
                >
                    <Checkbox.Group className="w-full mb-1">
                        {ownerAccess.map((is) => {
                            return (
                                <div key={is.id}>
                                    <Checkbox
                                        key={is.id}
                                        value={is.id}
                                        style={{ lineHeight: '32px' }}
                                    >
                                        {i18n.lang === 'en' ? is.name : is.name}
                                    </Checkbox>
                                    <br />
                                </div>
                            );
                        })}
                    </Checkbox.Group>
                </Form.Item>
            </Form>
            <ModalDiscardChanges
                open={openChange}
                handelOk={isChangeLocation ? handelOkLocation : handelOk}
                handelClose={() => setOpenChange(false)}
            />
            <ModalConfirm
                loading={loading}
                text={t('Do you want to confirm')}
                open={openConfirm}
                handelOk={onFinish}
                handelClose={() => setOpenConfirm(false)}
            />
        </div>
    );
}
